import React from 'react'
import './cmBox.css'

class CheckedCorMBox extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return(
            <div className="cmBox">
                <img className="cmBox-checked-img" src={require("../assert/triangle_blue.png")}></img>
                <p className="cmBox-word">{this.props.name}</p>
            </div>
        );
    }
}

class UnCheckedCorMBox extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return(
            <div className="cmBox">
                <p className="cmBox-word">{this.props.name}</p>
            </div>
        );
    }
}

export {CheckedCorMBox, UnCheckedCorMBox};